import React from "react";
import "./style.css";

function ResultOther(){

    return(
<>
<div id="emailNotSuccess">
    Your Message Was NOT Sent.
</div>

</>
    )
}

export default ResultOther;